import React, { Component } from "react";

import Layout from './components/Layout';

import store, { history } from './store';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import i18next from 'i18next';

let chatHash = [];

const THEME = createMuiTheme({
  typography: {
    useNextVariants: true,
    "fontFamily": "Brendon-Grotseque-regular",
  },
  palette: {
    primary: {
      main: "#b0c8db",
    },
    secondary: {
      main: "#2a4a9a"
    }
    // secondary: {
    //   light: palette.secondary.A200,
    //   main: palette.secondary.A400,
    //   dark: palette.secondary.A700,
    //   contrastText: getContrastText(palette.secondary.A400),
    // },
    // error: {
    //   light: palette.error[300],
    //   main: palette.error[500],
    //   dark: palette.error[700],
    //   contrastText: getContrastText(palette.error[500]),
    // },
  },
});


class App extends Component {

  tidioStyleHash = null;


  render() {
    // Set HTML lang attribute
    document.documentElement.lang = i18next.language.indexOf('de') == 0 ? 'de-CH' : 'en-GB';

    return (
      <MuiThemeProvider theme={THEME}>
        <Provider store={store}>
          <div className="App">
            <ConnectedRouter history={history}>
              <Layout />
            </ConnectedRouter>
          </div>
        </Provider>
      </MuiThemeProvider>
    );
  }

  componentDidMount() {

    const onTidioChatApiReady = () => {
      if (!window.tidioChatApi) return;
      
      if(chatHash.length>0){
        chatHash.forEach((chat) => {
          window.tidioChatApi.removeStyles(chat);
        })
        chatHash = [];
      }

      if (document.body.querySelector('.checkout-step-box')) {
        chatHash.push(window.tidioChatApi.adjustStyles(
          '#tidio { transform:scale(0.9); bottom: -60px !important; margin-right:auto;right: -30px !important; left:auto; }'
        ));
      }

      if (document.body.querySelector('.product.is-gray')) {

        chatHash.push(window.tidioChatApi.adjustStyles(
          '#tidio { transform:scale(0.9); bottom: -40px !important; margin-right:auto;left: 0px !important; }'
        ));
        chatHash.push(window.tidioChatApi.adjustStyles(
          '@media only screen and (max-width: 991px) { #tidio { transform:scale(0.9); margin-right:auto;bottom: -70px !important; left: 0px !important; } }'
        ));
      }

      if (document.body.querySelector('.cart-config.summary')) {
        chatHash.push(window.tidioChatApi.adjustStyles(
          '#tidio { transform:scale(0.9); bottom: -50px !important; margin-right:0px;right: 0px !important; left: auto !important; }'
        ));
        chatHash.push(window.tidioChatApi.adjustStyles(
          '@media only screen and (max-width: 991px) { #tidio { transform:scale(0.9); margin-right:auto;bottom: 10px !important; left: -25px !important; } }'
        ));
        chatHash.push(window.tidioChatApi.adjustStyles(
          '@media only screen and (max-width: 756px) { #tidio { transform:scale(0.9); margin-right:auto;bottom: -50px !important; left: -25px !important; } }'
        ));
      }
    };

    // If Tidio has already loaded
    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    }

    this.unlisten = history.listen(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          onTidioChatApiReady();
        });
      });
    });

    // If Tidio loads later
    document.addEventListener("tidioChat-ready", onTidioChatApiReady);

    // Cleanup on unmount
    this.cleanupTidio = () => {
      document.removeEventListener("tidioChat-ready", onTidioChatApiReady);
    };
  }

  componentWillUnmount() {
    if (this.cleanupTidio) this.cleanupTidio();
  }
}

export default App;




// TODO, add a 404 page not found.